export default "/images/f7e80599dbd7534fcd4fd31a721cee0e.avif";